import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';

/**
 * Relie des formes à une autre carte du projet — le « zaap » : en aperçu, cliquer la zone y emmène
 * le visiteur. Même logique que `linkUrlToShape` : une seule entrée d'historique/sauvegarde pour
 * tout le groupe, et seules les formes qui n'ont pas déjà `action: 'open_map'` la reçoivent.
 *
 * `targetMapId` est l'`id` du `MapModel` visé : c'est ce que `@tokamap/core` transporte dans
 * `Shape.targetDocumentId`, sans jamais l'interpréter, et ce qu'il sérialise en `extra.targetMapId`.
 */
export default async function linkMapToShape(shapeIds: string | string[], targetMapId: string) {
	const editor = currentEditorStore.get;
	const ids = Array.isArray(shapeIds) ? shapeIds : [shapeIds];
	const shapes = ids
		.map(id => editor.getAllShapes().find(s => s.id === id))
		.filter((s): s is NonNullable<typeof s> => s !== undefined);

	const idsNeedingAction = shapes.filter(s => s.action !== 'open_map').map(s => s.id);

	if (idsNeedingAction.length) {
		editor.setShapeAction(idsNeedingAction, 'open_map');
	}

	editor.setShapeTargetDocumentId(ids, targetMapId);
}
